import { render, staticRenderFns } from "./cancellation-terms.vue?vue&type=template&id=750f7998&"
import script from "./cancellation-terms.vue?vue&type=script&lang=js&"
export * from "./cancellation-terms.vue?vue&type=script&lang=js&"
import style0 from "./cancellation-terms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports